import { AppLayout, ViewLayout } from '@/components/Layout'

const otherRoutes = [
  {
    // 头部导航
    path: '/index',
    name: 'index',
    component: () => import('@/views/auth/index')
  },
  {
    // 首页
    path: '/homePage',
    name: 'homePage',
    component: () => import('@/views/auth/homePage')
  },
  {
    // 手机端主界面
    path: '/mobileIndex',
    name: 'mobileIndex',
    component: () => import('@/views/auth/mobileIndex')
  },
  {
    // 手机端主营业务
    path: '/mobileMainBusiness',
    name: 'mobileMainBusiness',
    component: () => import('@/views/auth/mobileMainBusiness')
  },
  {
    // 手机端经典案例
    path: '/mobileCase',
    name: 'mobileCase',
    component: () => import('@/views/auth/mobileCase')
  },
  {
    // 手机端新闻中心
    path: '/mobileNewsCenter',
    name: 'mobileNewsCenter',
    component: () => import('@/views/auth/mobileNewsCenter')
  },
  {
    // 手机端研究院
    path: '/mobileResearchInstituter',
    name: 'mobileResearchInstituter',
    component: () => import('@/views/auth/mobileResearchInstituter')
  },
  {
    // 手机端关于埃文
    path: '/mobileAboutAvi',
    name: 'mobileAboutAvi',
    component: () => import('@/views/auth/mobileAboutAvi')
  },
  {
    // 手机端公司简介
    path: '/mobileCompanyProfile',
    name: 'mobileCompanyProfile',
    component: () => import('@/views/auth/mobileCompanyProfile')
  },
  {
    // 手机端首席科学家
    path: '/mobileChiefScientist',
    name: 'mobileChiefScientist',
    component: () => import('@/views/auth/mobileChiefScientist')
  },
  {
    // 手机端企业文化
    path: '/mobileCorporateCulture',
    name: 'mobileCorporateCulture',
    component: () => import('@/views/auth/mobileCorporateCulture')
  },
  {
    // 手机端荣誉资质
    path: '/mobileHonorsQualifications',
    name: 'mobileHonorsQualifications',
    component: () => import('@/views/auth/mobileHonorsQualifications')
  },
  {
    // 手机端联系方式
    path: '/mobileContacInformation',
    name: 'mobileContacInformation',
    component: () => import('@/views/auth/mobileContacInformation')
  },
  {
    // 手机端加入低碳行业
    path: '/moblielowCarbonIndustry',
    name: 'moblielowCarbonIndustry',
    component: () => import('@/views/auth/moblielowCarbonIndustry')
  },
  {
    // 手机端合作伙伴
    path: '/mobileCooperativePartner',
    name: 'mobileCooperativePartner',
    component: () => import('@/views/auth/mobileCooperativePartner')
  },
  {
    // 手机端详情页
    path: '/mobileDetailsPage',
    name: 'mobileDetailsPage',
    component: () => import('@/views/auth/mobileDetailsPage')
  }, {
    // 手机端详情页
    path: '/mobileDetailsTwo',
    name: 'mobileDetailsTwo',
    component: () => import('@/views/auth/mobileDetailsTwo')
  },
  {
    // 主营业务
    path: '/mainBusiness',
    name: 'mainBusiness',
    component: () => import('@/views/auth/mainBusiness')
  },
  {
    // 客户案例
    path: '/customerStories',
    name: 'customerStories',
    component: () => import('@/views/auth/customerStories')
  },
  {
    // 培训中心
    path: '/trainingCenter',
    name: 'trainingCenter',
    component: () => import('@/views/auth/trainingCenter')
  },
  {
    // 新闻中心
    path: '/newsCenter',
    name: 'newsCenter',
    component: () => import('@/views/auth/newsCenter')
  },
  {
    // 关于埃文
    path: '/aboutAvi',
    name: 'aboutAvi',
    component: () => import('@/views/auth/aboutAvi')
  },

  // {
  //   // 地球牧歌俱乐部
  //   path: '/earthMuGe',
  //   name: 'earthMuGe',
  //   component: () => import('@/views/auth/earthMuGe')
  // },
  {
    // 平台伙伴
    path: '/platformPartners',
    name: 'platformPartners',
    component: () => import('@/views/auth/platformPartners')
  },
  {
    // 专家达人
    path: '/expert',
    name: 'expert',
    component: () => import('@/views/auth/expert')
  },
  {
    // 文本内容
    path: '/textContent',
    name: 'textContent',
    component: () => import('@/views/auth/textContent')
  },
  {
    // 插入尾部
    path: '/footer',
    name: 'footer',
    component: () => import('@/views/auth/footer')
  },
  {
    path: '/error',
    name: 'error',
    redirect: '404',
    component: ViewLayout,
    children: [
      {
        path: '404',
        name: '404',
        component: () => import(/* webpackChunkName: "404" */ '@/views/error/404')
      }
    ]
  }
]

export const appRoutes = [
  {
    path: '/',
    name: 'index',
    redirect: '/dashboard/analysis',
    component: AppLayout,
    children: [
      {
        path: 'table',
        name: 'table',
        meta: {
          title: '表格页',
          icon: 'table'
        },
        component: () => import(/* webpackChunkName: "table" */ '@/views/table/table')
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        meta: {
          title: 'Dashboard',
          icon: 'dashboard'
        },
        component: ViewLayout,
        children: [
          {
            path: 'analysis',
            name: 'dashboard_analysis',
            meta: {
              title: '分析页'
            },
            component: () => import(/* webpackChunkName: "analysis" */ '@/views/dashboard/analysis')
          },
          {
            path: 'monitor',
            name: 'dashboard_monitor',
            meta: {
              title: '监控页'
            },
            component: () => import(/* webpackChunkName: "monitor" */ '@/views/dashboard/monitor')
          },
          {
            path: 'v-charts',
            name: 'v-charts',
            meta: {
              title: 'v-charts'
            },
            component: () => import(/* webpackChunkName: "v-charts" */ '@/views/dashboard/vcharts')
          },
          {
            path: 'track',
            name: 'track',
            meta: {
              title: '轨迹图'
            },
            component: () => import(/* webpackChunkName: "track" */ '@/views/dashboard/track')
          }
        ]
      },
      {
        path: 'd3',
        name: 'd3',
        meta: {
          title: 'D3',
          icon: 'stock'
        },
        component: ViewLayout,
        children: [
          {
            path: 'bar',
            name: 'd3_bar',
            meta: {
              title: 'bar'
            },
            component: () => import(/* webpackChunkName: "tutorials" */ '@/views/d3/bar')
          },
          {
            path: 'line',
            name: 'd3_line',
            meta: {
              title: 'line'
            },
            component: () => import(/* webpackChunkName: "tutorials" */ '@/views/d3/line')
          }
        ]
      },
      {
        path: 'g2',
        name: 'g2',
        meta: {
          title: 'g2',
          icon: 'stock'
        },
        component: ViewLayout,
        children: [
          {
            path: 'bar',
            name: 'g2_bar',
            meta: {
              title: 'bar'
            },
            component: () => import(/* webpackChunkName: "tutorials" */ '@/views/g2/bar')
          },
          {
            path: 'line',
            name: 'g2_line',
            meta: {
              title: 'line'
            },
            component: () => import(/* webpackChunkName: "tutorials" */ '@/views/g2/line')
          }
        ]
      }
    ]
  }
]

const routes = [...otherRoutes, ...appRoutes]

export default routes
